import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FaChartBar,
  FaFileInvoiceDollar,
  FaUsers,
  FaShoppingBag,
  FaSignOutAlt,
  FaCalculator,
  FaFileInvoice,
  FaGraduationCap
} from 'react-icons/fa';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('caUser');
    navigate('/ca-login');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo-container">
          <FaCalculator className="logo-icon" />
          <div>
            <h3>CA Portal</h3>
            <span className="subtitle">Financial Analytics</span>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/ca-dashboard/overview" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <FaChartBar className="nav-icon" />
          <span>Overview</span>
        </NavLink>

        <NavLink to="/ca-dashboard/sales-report" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <FaFileInvoiceDollar className="nav-icon" />
          <span>Sales Report</span>
        </NavLink>
        {/* 
        <NavLink to="/ca-dashboard/user-financials" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <FaUsers className="nav-icon" />
          <span>User Financials</span>
        </NavLink> */}

        {/* <NavLink to="/ca-dashboard/all-orders" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <FaShoppingBag className="nav-icon" />
          <span>All Orders</span>
        </NavLink> */}

        <NavLink to="/ca-dashboard/gst-report" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <FaFileInvoice className="nav-icon" />
          <span>GST Return</span>
        </NavLink>

        <NavLink to="/ca-dashboard/training" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <FaGraduationCap className="nav-icon" />
          <span>Training</span>
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">CA</div>
          <div className="user-details">
            <span className="user-role">Chartered Accountant</span>
            <span className="user-status">
              <span className="status-dot"></span>
              Active
            </span>
          </div>
        </div>
        <button onClick={handleLogout} className="logout-btn">
          <FaSignOutAlt />
          <span>Logout</span>
        </button>
      </div>

      <style>{`
        .sidebar {
          width: 220px;
          background: #1e293b;
          color: white;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          position: fixed;
          top: 0;
          left: 0;
          box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
          z-index: 100;
        }

        .sidebar-header {
          padding: 20px 16px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          background: linear-gradient(135deg, #334155, #1e293b);
        }

        .logo-container {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .logo-icon {
          font-size: 2rem;
          color: #3b82f6;
        }

        .sidebar-header h3 {
          margin: 0;
          font-size: 1.25rem;
          font-weight: 700;
          color: white;
        }

        .subtitle {
          display: block;
          font-size: 0.7rem;
          color: #94a3b8;
          margin-top: 2px;
        }

        .sidebar-nav {
          flex: 1;
          padding: 16px 12px;
          display: flex;
          flex-direction: column;
          gap: 6px;
          overflow-y: auto;
        }

        .nav-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 14px;
          color: #cbd5e1;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.2s ease;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .nav-item:hover {
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
        }

        .nav-icon {
          font-size: 1.1rem;
          flex-shrink: 0;
        }

        .nav-item.active {
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          color: white;
          font-weight: 600;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
        }

        .nav-item.active .nav-icon {
          color: white;
        }

        .sidebar-footer {
          padding: 16px 12px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          background: #0f172a;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
          padding: 12px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 8px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .user-details {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
          min-width: 0;
        }

        .user-role {
          font-size: 0.85rem;
          font-weight: 600;
          color: white;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .user-status {
          font-size: 0.7rem;
          color: #94a3b8;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .status-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #22c55e;
          box-shadow: 0 0 6px rgba(34, 197, 94, 0.6);
        }

        .logout-btn {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
          border: none;
          padding: 10px 16px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .logout-btn:hover {
          background: linear-gradient(135deg, #dc2626, #b91c1c);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
        }

        .logout-btn:active {
          transform: translateY(0);
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 100%;
            position: relative;
            min-height: auto;
          }
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;
